import { QueryClient } from '@tanstack/react-query';
import { GlobalPermission } from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/user_pb';
import { LoaderFunctionArgs } from 'react-router';
import { statisticsQuery } from '~/pages/StatisticsPage/api/statistics.queries';
import { StatisticsModel } from '~/pages/StatisticsPage/models/StatisticsModel';
import { requireUserGlobalPermission } from '~/shared/auth/auth-utils';

export type StatisticsPageLoaderData = {
  statistics: StatisticsModel;
};

export const statisticsPageLoader =
  (queryClient: QueryClient) =>
  async ({
    request,
  }: LoaderFunctionArgs): Promise<StatisticsPageLoaderData | Response> => {
    await requireUserGlobalPermission(
      queryClient,
      request,
      GlobalPermission.STATISTICS,
    );

    const statistics = await queryClient.ensureQueryData(statisticsQuery);

    return { statistics };
  };
